import React, {Component} from "react";
import {connect} from "react-redux";
import {ReactSVG} from "react-svg";

import * as config from "../constants/config";
import * as changelogService from "../services/changelogService";
import * as tooltipHelper from "../helpers/tooltipHelper";
import * as helperActions from "../actions/helperActions";

import FramePanel from "./global/FramePanel";

import imgClose from "../resources/img/svgicons/close-black.svg";
import imgDeso from "../resources/img/deso-logo.png";
import imgLoader from "../resources/img/loader.svg";

class Error extends Component {
    constructor(props) {
        super(props);

        this.state = {
            version: changelogService.getLastClientVersion(),
            activeHelp: false,
            activeReport: false,
            reportSubject: "",
            reportContent: ""
        };
    }

    componentDidUpdate(prevProps) {
        if (!this.props.blocked && prevProps.blocked) {
            this.setState({
                activeReport: false,
                reportSubject: "",
                reportContent: ""
            });
        }
    }

    handleCloseModalClick = () => {
        this.setState({
            activeHelp: false,
            activeReport: false
        });
    };

    handleHelpClick = () => {
        this.setState({
            activeHelp: true,
            activeReport: false
        });
    };

    handleReportErrorClick = () => {
        if (!this.props.helperConnected) {
            this.props.dispatchConnectHelperAction();
        }

        this.setState({
            activeReport: true,
            activeHelp: false
        });
    };

    handleSubjectChange = (event) => {
        this.setState({
            reportSubject: event.target.value
        });
    };

    handleContentChange = (event) => {
        this.setState({
            reportContent: event.target.value
        });
    };

    handleSendButtonClick = () => {
        this.props.dispatchSendErrorReportAction(this.state.reportSubject, this.formatMessage());
    };

    handleInputFocus = (event) => {
        event.target.select();
    };

    formatMessage = () => {
        let formattedMessage = [];
        let textRows = this.state.reportContent.split("\n");
        for (let row of textRows) {
            formattedMessage.push(row);
        }

        formattedMessage.push("");
        formattedMessage.push("Logs: ");
        formattedMessage.push("RenderError");
        formattedMessage.push("license: " + this.props.license);
        formattedMessage.push("posName: " + this.props.pos.name);
        formattedMessage.push("posStreet: " + this.props.pos.street);
        formattedMessage.push("posCountry: " + this.props.pos.country);
        formattedMessage.push("posRegion: " + this.props.pos.region);
        formattedMessage.push("posCity: " + this.props.pos.city);
        formattedMessage.push("posZip: " + this.props.pos.zip);
        formattedMessage.push("swVersion: " + this.props.swVersion);
        formattedMessage.push("mainDbVersion: " + this.props.mainDbVersion);
        formattedMessage.push("localDbVersion: " + this.props.localDbVersion);
        formattedMessage.push("");
        return formattedMessage.join("<br>");
    };

    getSendButton = () => {
        if (!this.props.helperConnected || this.props.blocked) {
            return "";
        }

        if (this.state.reportSubject === "" || this.state.reportContent === "") {
            return (
                <span>
                    <button className="btn btn-sm btn-info margin-left-10" disabled>
                        Send
                    </button>
                </span>
            );
        }

        return (
            <span>
                <button className="btn btn-sm btn-info margin-left-10" onClick={this.handleSendButtonClick}>
                    Send
                </button>
            </span>
        );
    };

    getHelpInfo = () => {
        if (this.props.helpSettings.message === "") {
            return (
                <div className="modal-content text-center">
                    <div>There is no help for your license available, ask your supplier to add it.</div>
                    <div>Powered by DESO.</div>
                    <div>
                        <img src={imgDeso} className="deso-logo" alt="deso logo" />
                    </div>
                    <div className="help-link">
                        <span>For more information, please visit</span>
                        <a
                            className="color-primary"
                            href={this.props.helpLink}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Help Center
                        </a>
                    </div>
                </div>
            );
        }

        return (
            <div className="modal-content text-center">
                <div className="margin-bottom-8" dangerouslySetInnerHTML={{__html: this.props.helpSettings.message}} />
                <div>{this.props.helpSettings.telephone}</div>
                <div>{this.props.helpSettings.email}</div>
                <div className="help-link">
                    <span>Visit</span>
                    <a className="color-primary" href={this.props.helpLink} target="_blank" rel="noopener noreferrer">
                        Help Center
                    </a>
                </div>
            </div>
        );
    };

    showHelpModal = () => {
        if (!this.state.activeHelp) {
            return "";
        }

        return (
            <div id="modal" className="default-modal help-modal" style={{WebkitAppRegion: "no-drag"}}>
                <header className="color-primary">
                    Help
                    <div className="modal-close" onClick={this.handleCloseModalClick}>
                        <ReactSVG src={imgClose} className="close-img" alt="close" />
                    </div>
                </header>
                {this.getHelpInfo()}
                <div className="col-xs-12 text-right modal-footer">
                    <button onClick={this.handleCloseModalClick} className="btn btn-info btn-md pull-right">
                        Close
                    </button>
                </div>
            </div>
        );
    };

    getReportModalContent = () => {
        if (!this.props.helperConnected || this.props.blocked) {
            return (
                <div className="modal-content">
                    <div className="loader">
                        <img alt="loading" src={imgLoader} />
                    </div>
                </div>
            );
        }

        return (
            <div className="modal-content">
                <div className="row select-machine-title">
                    <div className="col-xs-2">Subject:</div>
                    <div className="col-xs-10">
                        <input
                            className="input-dark"
                            type="text"
                            value={this.state.reportSubject}
                            onChange={this.handleSubjectChange}
                            onFocus={this.handleInputFocus}
                        />
                    </div>
                </div>
                <div className="row select-machine-title">
                    <div className="col-xs-2">Content:</div>
                    <div className="col-xs-10">
                        <textarea
                            className="input-dark"
                            type="text"
                            value={this.state.reportContent}
                            onChange={this.handleContentChange}
                            onFocus={this.handleInputFocus}
                        />
                    </div>
                </div>
            </div>
        );
    };

    showReportModal = () => {
        if (!this.state.activeReport) {
            return "";
        }

        return (
            <div id="modal" className="default-modal bug-report-modal" style={{WebkitAppRegion: "no-drag"}}>
                <header className="color-primary">
                    Bug report
                    <div className="modal-close" onClick={this.handleCloseModalClick}>
                        <ReactSVG src={imgClose} className="close-img" alt="close" />
                    </div>
                </header>
                {this.getReportModalContent()}
                <div className="col-xs-12 text-right modal-footer">{this.getSendButton()}</div>
            </div>
        );
    };

    getClassName = () => {
        let className = "redlike-style";

        if (this.props.blocked) {
            className += " blocked-ui";
        }

        return className;
    };

    render() {
        return (
            <div className={this.getClassName()} style={{WebkitAppRegion: "drag"}}>
                <FramePanel />
                {this.showHelpModal()}
                {this.showReportModal()}
                <div className="welcome">
                    <div className="welcome-window">
                        <div className="redlike-logo-blue" />
                    </div>
                    <div className="error-info" style={{WebkitAppRegion: "no-drag"}}>
                        An unexpected error occurred. Contact our support at {this.props.helpSettings.email} or report
                        this error, and we&apos;ll get back to you as soon as we can.
                        <button className="btn btn-primary btn-xs" onClick={this.handleReportErrorClick}>
                            Report error
                        </button>
                        <button className="btn btn-primary btn-xs" onClick={this.handleHelpClick}>
                            Help
                        </button>
                    </div>
                    <div className="footer">
                        <span data-text={this.props.redlikeRevision} onMouseEnter={tooltipHelper.createTooltip}>
                            Version {this.state.version}
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStoreToProps = (store) => {
    let pos = {
        _name: "",
        _street: "",
        _country: "",
        _region: "",
        _city: "",
        _zip: ""
    };
    let props = {
        helpSettings: store.settings.helpSettings,
        helpLink: store.settings.helpLink || config.HELP_ON_REDLIKE,
        helperConnected: store.helper.connected,
        blocked: store.navigation.blocked,
        license: null,
        pos: null,
        swVersion: store.module.softwareVersion,
        mainDbVersion: null,
        localDbVersion: null
    };
    if (store.license.uuid !== null) {
        props.license = store.license.uuid;
    }
    if (store.license.registrationData.pointOfSale !== pos) {
        props.pos = store.license.registrationData.pointOfSale;
    }
    if (store.server.activeDatabase !== null) {
        props.mainDbVersion = store.server.activeDatabase.main.version;
        props.localDbVersion = store.server.activeDatabase.local.version;
    }
    return props;
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchConnectHelperAction: (ip) => {
            dispatch(helperActions.connectHelper(ip));
        },
        dispatchSendErrorReportAction: (subject, content) => {
            dispatch(helperActions.sendErrorReport(subject, content));
        }
    };
};

export default Error = connect(mapStoreToProps, mapDispatchToProps)(Error);
